<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <h2>
          {{ $t('display/elevator:edit.titles.add') }}
        </h2>

        <v-container class="register-border">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="6" class="mx-auto">
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                          outlined
                          v-model="elevator.name"
                          :label="$t('common:name') + '/' + $t('common:description')"
                          :rules="[ruleRequired($t('utils:rules.required'))]"
                      />

                      <h3>
                        {{ $t('common:address') }}
                      </h3>

                      <v-text-field
                          outlined
                          v-model="elevator.address"
                          :label="$t('common:street')"
                          :rules="[ruleRequired($t('utils:rules.required'))]"
                      />

                      <v-row>
                        <v-col cols="12" md="12" class="pl-0 pr-0 pb-0 pt-0">
                          <v-container>
                            <v-row>
                              <v-col class="pt-0 pb-0">
                                <v-text-field
                                    outlined
                                    v-model="elevator.zip"
                                    :label="$t('common:zip')"
                                    :rules="[ruleRequired($t('utils:rules.required'))]"
                                />
                              </v-col>

                              <v-col class="pt-0 pb-0">
                                <v-text-field
                                    outlined
                                    v-model="elevator.city"
                                    :label="$t('common:city')"
                                    :rules="[ruleRequired($t('utils:rules.required'))]"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-col>
                      </v-row>

                      <v-select
                          :items="countries"
                          item-text="translatedName"
                          item-value="id"
                          :menu-props="{bottom: true, offsetY: true}"
                          v-model="elevator.country"
                          outlined
                          clearable
                          :label="$t('common:country')"
                          :rules="[ruleRequired($t('utils:rules.required'))]"
                      />

                      <v-select
                          :items="emergencies"
                          item-text="name"
                          item-value="id"
                          :menu-props="{bottom: true, offsetY: true}"
                          v-model="elevator.emergencyCenter"
                          outlined
                          clearable
                          :label="$t('display/elevator:edit.labels.data-tab.emergency-center')"
                          :rules="[ruleRequired($t('utils:rules.required'))]"
                      />

                      <v-text-field
                          outlined
                          v-model="elevator.technicianName"
                          :label="$t('display/elevator:edit.labels.hardware-tab.technician-name')"
                      />

                      <v-text-field
                          outlined
                          v-model="elevator.technicianPhone"
                          :label="$t('display/elevator:edit.labels.hardware-tab.technician-phone')"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn

                          outlined
                          color="primary"
                          @click="saveElevator"
                      >{{ $t('buttons:save') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Utils from '@/modules/core/services/utils';
import Elevator from "@/modules/display/data/elevator";
import InfoService from "@/modules/core/services/info-service";
import ElevatorService from "@/modules/display/services/elevator-service";
import EmergencyCenterService from "@/modules/display/services/emergency-center-service";
import {ruleRequired} from '@/modules/core/services/rules';

export default {
  name: "RegisterElevator",
  components: {},
  data() {
    return {
      elevator: new Elevator(),
      countries: null,
      emergencies: null
    }
  },
  methods: {
    ruleRequired,
    saveElevator() {
      if (!this.$refs.form.validate()) {
        Utils.showFailureSnackbar(this.$t('snackbar:empty-fields'));
        return;
      }

      ElevatorService.saveByTechnical(
          this.elevator,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('common:elevator')}));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('common:elevator')}));
          }
      )
    },
    loadCountries() {
      InfoService.readOptionsByUrl(
          'country',
          (response) => {
            this.countries = Utils.translateAllCountries(response);
          }
      )
    },
    loadEmergencyCenters() {
      EmergencyCenterService.readAllFromAPI(
          (response) => {
            this.emergencies = response.data;
          }
      )
    },
    loadElevator() {
      let id = this.$route.params.id;
      ElevatorService.loadElevatorForRegister(
          id,
          (response) => {
            this.elevator = response.data;
          },
          () => {
             window.location.replace('/home');
          }
      )
    }
  },
  created() {
    this.loadElevator();
    this.loadCountries();
    this.loadEmergencyCenters();
  }
}
</script>

<style>
.log-container {
  border: 1px solid grey;
  border-radius: 4px;
  margin-bottom: 20px;
}

.register-border {
  background-color: #fff;
}

.comment-item {
  margin: 0;
  padding: 0;
}

.contact-item {
  padding: 10px 5px;
  border: 1px solid grey;
  border-radius: 4px;
  margin: 10px 0;
}
</style>